import React from 'react';
import { Icon } from '@mui/material';

/** Snackbar payload for setAlerts after copying settings (tag clipboard or location-access clipboard). */
export function settingsCopiedSnackAlert() {
  return {
    message: () => (
      <div>
        Settings Copied!
        <br />
        Use <Icon>post_add_oulined</Icon> to paste on another row.
      </div>
    ),
  };
}
